import { Injectable } from '@angular/core';
import { ImmoIPTourRouteCheckedChangesObject } from './immo-ip-tour-route-checked-changes-object';
import { ExpiredImmoIPTourRouteCheckedChangesRemover } from './expired-immo-ip-tour-route-checked-changes-remover';
import { AbstractOfflineStorageAsyncTimestampService } from '../abstract/abstract-offline-storage-async-timestamp.service';
import { NgForage } from 'ngforage';
import { NgForageTimestampService } from '../../ng-forage/ng-forage-timestamp.service';
import { GeneralHelper } from 'src/app/helpers/general-helper';

@Injectable({
  providedIn: 'root',
})
export class ImmoIPTourRouteCheckedChangesService extends AbstractOfflineStorageAsyncTimestampService<
  number,
  ImmoIPTourRouteCheckedChangesObject,
  ExpiredImmoIPTourRouteCheckedChangesRemover
> {
  constructor(
    protected ngForage: NgForage,
    protected ngForageTimestampService: NgForageTimestampService
  ) {
    super(
      'immo-ip-tour-route-checked-change-',
      'immo-ip-tour-route-checked-changes',
      ngForage,
      ngForageTimestampService
    );
  }

  protected instantiateRemover(): ExpiredImmoIPTourRouteCheckedChangesRemover {
    return new ExpiredImmoIPTourRouteCheckedChangesRemover(
      this,
      this.ngForage,
      this.ngForageTimestampService
    );
  }

  public override cleanupOfflineObject(
    object: ImmoIPTourRouteCheckedChangesObject
  ): Promise<void> {
    //Method not implemented.
    return Promise.resolve();
  }
  protected override verifyToStoreObject(
    object: ImmoIPTourRouteCheckedChangesObject
  ): void {
    if (object == null || object.id == null) {
      throw new Error(
        'immoIPTourRouteCheckedChangesObject must not be null and id must not be null'
      );
    }
  }

  public override convertToID(o: any): number {
    const toReturn = GeneralHelper.isNumeric(o) ? o : Number(o);
    if (!GeneralHelper.isNumeric(toReturn)) {
      throw new Error(`${o} could not be converted to number`);
    }
    return toReturn;
  }

  protected override stringifyID(id: number): string {
    return id.toString();
  }
}
